module.exports = __webpack_public_path__ + "img/PDAC1_pDC.19f0e8a9.png";